<div class="spinner">
  <div></div><div></div><div></div><div></div>
  <span class="progress" *ngIf="progress">{{ +progress }}%</span>
</div>
